export default "__VITE_ASSET__1ae6f0df__"